import type { SxProps, Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'

/** Outer panel for each Environment Config tab section (light + dark). */
export function environmentConfigSectionRootSx(theme: Theme): SxProps<Theme> {
  return {
    bgcolor: 'background.paper',
    backgroundImage: 'none',
    minHeight: '100%',
    p: { xs: 2, sm: 3, md: 4 },
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: theme.shadows[2],
  }
}

/** Section separators between ConfigSection blocks (subtle primary tint). */
export function environmentConfigSectionDividerSx(theme: Theme): SxProps<Theme> {
  return {
    my: 4,
    borderColor: alpha(theme.palette.primary.main, 0.22),
  }
}
